<template>
  <div class="container cpo-about-director">
    <div class="my-3">
      <router-link :to="{ name: 'about-index' }" class="nav-link"><v-icon left>mdi-arrow-left</v-icon> {{ $t("about.return") }}</router-link>
    </div>
    <div class="mt-6 layout flex-column flex-md-row-reverse content">
      <div class="flex xs12 md5 pl-md-12">
        <img src="/img/yulong.jpg" style="width: 100%" />
      </div>
      <div class="flex xs12 md7">
        <h1>余隆</h1>
        <h2>艺术总监/首席指挥</h2>
        <br />
        <p>
          余隆是活跃于国际乐坛的最杰出的中国指挥家，被纽约时报誉为“中国古典音乐届最具影响力的人物”，现任中国爱乐乐团艺术总监、首席指挥，北京国际音乐节艺术委员会主席，上海交响乐团和广州交响乐团音乐总监，上海夏季音乐节的联合总监，以及香港管弦乐团首席客席指挥。余隆创办了北京国际音乐节并于1998年至2018年间担任其艺术总监。
        </p>
        <p>
          在2019／20乐季中，除了在中国的演出，余隆以客座指挥英国皇家爱乐乐团、纽约爱乐乐团、伯尔尼交响乐团，荷兰广播爱乐乐团，阿德莱德交响乐团、奥克兰爱乐乐团、台湾爱乐乐团以及新加坡交响乐团等。2019年夏天，余隆与上海交响乐团的巡演之旅至美国和欧洲等地，包括了BBC逍遥音乐节、爱丁堡国际艺术节、拉维尼亚艺术节，琉森音乐节等。
        </p>
        <p>
          2018年6月，余隆与德意志留声机（以下称“DG”）签署独家录音合约，成为DG旗下签约的第一位中国指挥家。作为2018／19乐季德意志留声机120周年庆典的一部分，余隆于18年10月在北京的紫禁城太庙指挥了一场盛大的启动音乐会，同台艺术家包括阿依达·加里芙琳娜和丹尼尔·特里福诺夫，该音乐会随后发行了唱片。
        </p>
        <p>
          余隆指挥过世界各地一系列知名交响乐团和歌剧院，其中包括纽约爱乐乐团、芝加哥交响乐团、费城交响乐团、洛杉矶爱乐乐团、蒙特利尔交响乐团、华盛顿国家交响乐团、辛辛那提交响乐团、巴黎管弦乐团、班贝格交响乐团、汉堡国家歌剧院、柏林广播交响乐团、莱比锡广播交响乐团、汉堡北德广播交响乐团、慕尼黑爱乐乐团、悉尼交响乐团、墨尔本交响乐团、BBC交响乐团、香港管弦乐团、东京爱乐乐团和新加坡交响乐团等。余隆多年来与以艾莉森·巴尔松、曹秀美、郎朗、马友友、米沙·麦斯基、马克西姆·文格洛夫和王羽佳为代表的众多国际著名艺术家保持频繁合作。
        </p>
        <p>
          2008年，余隆指挥中国爱乐乐团作为首支中国乐团在梵蒂冈城保罗六世礼堂演出，教宗本笃十六世观看演出，成为令全世界瞩目的中西方文化交流盛事。2014年余隆率领中国爱乐乐团在英国BBC逍遥音乐节上演出，该音乐会的电视转播在英国收视率过百万，余隆和中国爱乐也成为了首位中国指挥和中国乐团登上这一舞台。
        </p>
        <p>
          为了推动中国交响乐的宏观发展，余隆联合了上海交响乐团、上海音乐学院和纽约爱乐创建了中国首个乐队学院。他的前瞻性愿景着眼于向中国正在成长中的古典乐观众介绍重要的西方作品，包括瓦格纳的指环王系列、马勒系列，还有理查德·施特劳斯、本杰明·布里顿及其他作曲家作品。2014年，纽约爱乐乐团任命余隆为乐团国际顾问委员会荣誉成员。这一由12名成员组成的委员会是一个倡导者和大使们与各国个人和机构联结的关系网，以培养纽约爱乐长期在全球范围内的影响力。
        </p>
        <p>
          余隆与广州交响乐团的初次合作是1993年，并于2003年成为该团音乐总监。任职期间余隆曾率领乐团赴欧洲和埃及巡演，在巴黎香榭丽舍剧院、卢森堡音乐学院、阿姆斯特丹音乐厅和开罗歌剧院演出。
        </p>
        <p>
          余隆1964年出生于上海的音乐世家，自幼随外祖父、著名作曲家丁善德教授学习音乐。后求学于上海音乐学院和德国柏林高等艺术大学。1992年，余隆担任中央歌剧院首席指挥。同年，他参与创办了中国的新年音乐会系列，并连续三年担任指挥。1993年起，余隆连续五年为香港市政局指挥歌剧演出。
        </p>
        <p>
          鉴于余隆在推动当今世界古典音乐事业发展和促进国际间文化交流方面所做的突出贡献，法国政府特别授予余隆“法兰西文学艺术骑士勋章”；2002年，德国万宝龙文化基金会向余隆颁发了年度“万宝龙卓越艺术成就奖”；2005年，意大利总理贝鲁斯科尼向余隆颁发了“共和国骑士勋章”；2014年，他获得象征着法国最高荣誉典属体系的荣誉军团骑士勋章；2015年，余隆荣获“全国优秀文学艺术工作者”荣誉称号，并获得由美国大西洋理事会颁发的“全球公民”奖，以及由耶鲁大学音乐学院颁发的“桑福德奖章”；2016年，余隆当选美国艺术与科学院外籍荣誉院士，并于同年被授予德意志联邦共和国十字勋章；2018年，余隆被香港演艺学院授予荣誉博士学位。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
